/**
 * zeluslugi.ru
 */

function reachGoal(target) {
    if (target) {
        try {
            ym(28646881, 'reachGoal', target);
            console.log('reach goal: ' + target);
        } catch (e) {
            try {
                yaCounter28646881.reachGoal(target);
                console.log('reach goal: ' + target);
            } catch (e) {
                console.error(e);
            }
        }
    }
}

/**
 * Лайтбокс для картинок
 */
$(function () {
    $('.fancybox').fancybox();
});

$(function () {

    $(window).trigger('validatorsLoaded'); // Иначе не загружается локализация

    // $(document).on('hidden.bs.modal', '.modal', function () {
    //     $('.modal:visible').length && $(document.body).addClass('modal-open');
    // });

    $('#Offer').on('hidden.bs.modal', function () {
        $(this).find('form').data('goal', null);
        $(this).find('form').find('[type="submit"]').attr('disabled', false);
    });

    $('#RequestForm').on('show.bs.modal', function () {
        $(this).find('form')[0].reset();
        $(this).find('.Form').removeClass('FormComplete').removeClass('FormError');
        $(this).find('.error').removeClass('error');
        $(this).find('.has-danger').removeClass('has-danger');
        $(this).find('.form-error').remove();
    });

    $('form').attr('novalidate', true).each(function () {
        let $thisForm = $(this);
        let enableScrollOnError = !!$thisForm.data('enableScrollOnError');
        $.validate({
            form                   : $thisForm,
            modules                : 'file',
            lang                   : 'ru',
            scrollToTopOnError     : false,
            borderColorOnError     : '',
            inputParentClassOnError: 'has-danger',
            onElementValidate      : function (valid, $el, $form, errorMess) {
                if (!valid) {
                    if (!$el.is(':focus')) {
                        $el.parent()
                            .addClass('Shake')
                            .on('animationend webkitAnimationEnd', function () {
                                $el.parent().removeClass('Shake');
                            });
                    }
                }
            },
        });

        const $reCaptcha = $thisForm.find('[name=g-recaptcha-response]');
        if (!$reCaptcha.length) {
            $('<input>', {
                type: 'hidden',
                name: 'g-recaptcha-response',
            }).appendTo($thisForm);
        }
    });

    const reCaptchaKey = '6LcL2-IZAAAAAIjisay5HIa8sSikj2H19Mxz42JR';

    $('form[data-toggle="ajax"]').on('submit', function (e) {
        e.preventDefault();
        let $form = $(this);
        let $button = $('[type="submit"]', $form);

        let data = $form.serialize();
        let action = $form.data('action');
        let method = $form.attr('method');
        let response = $form.data('response') || 'html';
        let goal = $form.data('goal');

        $button.attr('disabled', true);

        grecaptcha.ready(() => {
            grecaptcha.execute(reCaptchaKey, { action: 'submit' })
                .then(token => {
                    const $reCaptcha = $form.find('[name=g-recaptcha-response]');
                    $reCaptcha.val(token);
                    data = $form.serialize();
                    // console.log('ReCaptcha: ', token);

                    if (isDev()) {
                        console.log({ data: Object.fromEntries(new URLSearchParams(data)) });
                    }

                    $button.attr('disabled', true);
                    $form.trigger('beforeSend');

                    $.ajax({
                        url     : action,
                        type    : method,
                        data    : data,
                        dataType: response,
                    }).then(function (response) {
                        // console.log('success', response);
                        if (response.status === 'success') {
                            reachGoal(goal);
                            $form[0].reset();
                        }
                        $button.attr('disabled', false);
                        $form.trigger('success', [response]);
                        $form.addClass('FormComplete');
                        // $form.find('.FormMessage').append(data.debug.message);
                    }).fail(function () {
                        // console.log('error', arguments);
                        $button.attr('disabled', false);
                        $form.trigger('error');
                        $form.addClass('FormError');
                    });
                })
                .catch(function () {
                    $button.attr('disabled', false);
                });
        });
    });
});

(function () {
    $('form.js-ask-form').each(function () {
        let $form = $(this);
        $form.on('success', function (e, response) {
            // console.log(response);
            const $modal = $('#CustomMessage');
            $modal.find('.Header').html(response.title);
            $modal.find('.Desc').html(response.message);
            $modal.modal('toggle');
        });
    });
})();

/**
 * Карусель отзывов
 */
$(function () {
    let responsiveVariants = {
        3: {
            0   : { items: 1 },
            420 : { items: 2 },
            640 : { items: 3 },
            860 : { items: 3 },
            1080: { items: 3 },
        },
        4: {
            0   : { items: 1 },
            420 : { items: 2 },
            640 : { items: 3 },
            860 : { items: 3 },
            1080: { items: 4 },
        },
        5: {
            0  : { items: 1 },
            420: { items: 2 },
            640: { items: 3 },
            860: { items: 4 },/*, 1080: {items: 6}*/
        },
    };

    $('.js-reviews-carousel').each(function () {
        let $carousel = $(this);
        let row = parseInt($carousel.data('per-row'));

        if (isNaN(row) || row < 3 || row > 5) {
            row = 5;
        }

        $carousel.owlCarousel({
            items     : 5,
            margin    : 20,
            dots      : true,
            nav       : false,
            responsive: responsiveVariants[row],
        });
    });
});

/**
 * Респонсивим таблицы в контенте
 */
$(function () {
    let timeout;

    $('.page__main').find('table').each(function () {
        $(this)
            .wrap(
                '<div class="table-responsive"><div class="table-responsive__viewport"></div></div>');
    });

    $(window).on('resize', function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            $('.table-responsive').each(function () {
                let $outer = $(this);
                let $viewport = $outer.children('.table-responsive__viewport');
                let $table = $viewport.children('table');

                $outer.toggleClass(
                    'table-responsive_has-scroll',
                    ($table.outerWidth() > $viewport.outerWidth()),
                );
            });
        }, 300);
    });
});

/**
 * Слайдер на главной
 */
$(function () {
    $('.slider').owlCarousel({
        items             : 1,
        nav               : true,
        dots              : true,
        loop              : true,
        autoplayHoverPause: true,

        responsive: {
            0  : {
                autoplay: false,
            },
            768: {
                autoplay: true,
            },
        },
    });
});
